import {
    Facebook,
    Instagram,
    MailOutline,
    Phone,
    Pinterest,
    Room,
    Twitter,
  } from "@material-ui/icons";

  import styled from "styled-components";

import {
  Box,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography
} from "@mui/material";
  
  const Container = styled.div`
    display: flex;
    padding: 25px 17px;
    background-color: #CDE4DB;
  `;
  
  const Title = styled.h3`
    margin-bottom: 10px;
  `;
  
  const Right = styled.div`
    flex: 1;
    padding: 20px;
  `;
  
  const ContactItem = styled.div`
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  `;
  
  const Payment = styled.img`
      width: 50%;
  `;
  
  const Footer = () => {
    return (
      <Container>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Title>Hubungi Kami</Title>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" color="darkslategrey" display="flex" alignItems="center">
              <Room style={{marginRight:"10px"}}/> Bandung
            </Typography>
          </Grid>
          <Grid item xs={12}>
          <Typography variant="subtitle1" color="darkslategrey" display="flex" alignItems="center">
              <Phone style={{marginRight:"10px"}}/> +62 22 87353451
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" color="darkslategrey" display="flex" alignItems="center">
              <MailOutline style={{marginRight:"10px"}} /> wanojahijab@gmail.com
            </Typography>
          </Grid>
          <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
            <Typography variant="subtitle2" color="darkgrey" sx={{ margin: '10px 0px'}}>
              copyright &copy; 2022 All rights reserved | WNJ IT Support
            </Typography>
          </Grid>
        </Grid>
      </Container>
    );
  };
  
  export default Footer;